"use client";

import HeaderBackground from "@/components/ui/header-background";
import BannerSection from "./components/banner-section";
import AwardSection from "./components/award-section";
import CatalogSection from "./components/catalog-section";
import NewsSection from "./components/news-section";
import CollectionSection from "./components/collection-section";
import BlockSection from "./components/block-section";

const HomeView = () => {
  return (
    <>
      <HeaderBackground type="black" />
      <BannerSection />
      {/* TODO: Скрыли, пока не будет готова авторизации */}
      {/* {locale === Locales.UK && <DownloadBlock variant="white" />} */}
      <CollectionSection />
      <AwardSection />
      <BlockSection />
      <NewsSection />
      <CatalogSection />
    </>
  );
};

export default HomeView;
